/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

import {
  CmsPageContentType,
  CmsRouterContentIdentifier,
  HardwareOptionType,
  ReduxStateType
} from '@/types/fitting-hardware';
import {currencyParts, formatPrice, interpolate} from '@/utils';
import ItemPanel from './ItemPanel';
import {getCmsContent} from "@/redux/fitting-hardware";
import {connect} from "react-redux";

export interface ItemProps {
  hardwareOption: HardwareOptionType
  activationFeeText: string
  checked?: boolean
  onClick: VoidFunction
}
export interface StateProps {
  cmsContent: CmsPageContentType
}

const Item = ({
  hardwareOption,
  activationFeeText,
  checked = false,
  onClick,
  cmsContent,
}: StateProps & ItemProps) => {
  const { charges } = hardwareOption;
  const { name, hint } = hardwareOption.cmsContent;
  const [euros, cents] = charges ? currencyParts(charges.recurringCosts) : [undefined, undefined];
  const formattedFee = charges && formatPrice(charges.nonRecurringCosts);
  const routerNextPrice:string[]|undefined = charges?.nextPriceCharges.filter(charges=>charges.startingMonth>1)
      .map(value =>interpolate(cmsContent[CmsRouterContentIdentifier.RouterPriceInfo],
          {startMonth:value.startingMonth
            ,value:value.recurringCosts}));
  const styles = `
  @media (max-width: 359px) {
  .small-screen{
  display: inline-flex;
  }
  .big-screen {
  display: none;
  }
  }
  
  @media (min-width: 360px) {
  .small-screen{
  display: none;
  }
  .big-screen {
  display: inline-flex;
  }
  }
  `;

  return (
      <>
        <style>{styles}</style>
        <ItemPanel onClick={onClick}>
          <input type="radio" readOnly checked={checked} />
          <div className="panel-body">
            <label>
          <span className="text panel-label">
            <strong dangerouslySetInnerHTML={{ __html: name.rendered }} />
            {hint
                ? <span className="panel-subline" dangerouslySetInnerHTML={{ __html: hint.rendered }} />
                : <span className="panel-subline" >{`${activationFeeText} ${formattedFee}`}</span>}
          </span>
              {charges && (
                  <span className="details" style={{ minWidth: '50px' }}>
            <span className="price price-small price-prefixed big-screen" style={{ minWidth: '50px' }}>
              <span className="cond ">mtl.</span>
              <span className="sum">{euros}</span>
              <span className="suffix">{cents}</span>
              <span className="currency">€</span>
              {routerNextPrice? routerNextPrice.map((value) =>
                  <span className="cond"> {value+' €'} </span>):''}
            </span>
            <span className="price price-left small-screen" style={{ minWidth: '50px' }}>
              <span className="cond"><strong>mtl.</strong></span>
              <span className="sum">{euros}</span>
              <span className="suffix">{cents}</span>
              <span className="currency">€</span>
              {routerNextPrice? routerNextPrice.map((value) =>
                  <span className="cond"> {value+' €'} </span>):''}
            </span>
          </span>
              )}
            </label>
          </div>
        </ItemPanel>
      </>

  );
};
const mapStateToProps = (state: ReduxStateType): StateProps => ({
  cmsContent: getCmsContent(state)
});
export default connect(mapStateToProps)(Item);
